import { ChangeEvent } from "react";
import { useField } from "formik";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

interface Props {
  name: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  [key: string]: any;
}

function FormField({ name, onChange, ...rest }: Props): JSX.Element {
  const [field, meta, helpers] = useField(name);

  return (
    <MDBox mb={1.5}>
      <MDInput
        variant="standard"
        fullWidth
        {...field}
        {...rest}
        name={name}
        error={Boolean(meta.touched && meta.error)}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          field.onChange(e);
          if (!meta.touched) helpers.setTouched(true, false);
          onChange?.(e);
        }}
      />
      {meta.touched && meta.error ? (
        <MDBox mt={0.75}>
          <MDTypography component="div" variant="caption" color="error" fontWeight="regular">
            {meta.error}
          </MDTypography>
        </MDBox>
      ) : null}
    </MDBox>
  );
}

export default FormField;
